import { getRequestQueryKey as getExternalRequestQueryKey } from "@synthesis/shared-services/external/application/hooks";
import { getRequestQueryKey as getInternalRequestQueryKey } from "@synthesis/shared-services/internal/application/hooks";
import { useQueryClient } from "@tanstack/react-query";

import { ExportApplicationButton, toExportItemFromDetail } from "../../../components/export-application";
import { useClientType } from "../../../shared/hooks/use-client-type";
import type { ApplicationDetail } from "../application-detail-page.lib";

type ApplicationDetailExportButtonProps = {
  application: ApplicationDetail;
  disabled?: boolean;
};

export const ApplicationDetailExportButton = ({ application, disabled }: ApplicationDetailExportButtonProps) => {
  const clientType = useClientType();
  const queryClient = useQueryClient();

  return (
    <ExportApplicationButton
      applications={[toExportItemFromDetail(application, clientType)]}
      disabled={disabled || !application.requestId}
      onExported={async (ids) => {
        const requestId = ids[0];

        if (!requestId) {
          return;
        }

        if (clientType === "internal") {
          await queryClient.invalidateQueries({ queryKey: getInternalRequestQueryKey({ path: { id: requestId } }) });
        } else {
          await queryClient.invalidateQueries({ queryKey: getExternalRequestQueryKey({ path: { id: requestId } }) });
        }
      }}
    />
  );
};
